export default __webpack_public_path__ + "static/media/futura-bold.9f7b4358.woff2";